import { useEffect } from 'react';
import { Create, useForm } from '@refinedev/antd';
import { Form, Input, Select } from 'antd';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import type { SubscriptionTier } from '@lebinatikra/shared-types';

interface OrgForm {
  community_id: string;
  name: string;
  slug: string;
  billing_contact?: string;
  subscription_tier: SubscriptionTier;
}

const TIERS: SubscriptionTier[] = ['free', 'starter', 'growth', 'enterprise'];

export function OrganizationCreate() {
  const { t } = useTranslation();
  const { communityId } = useParams();
  const { formProps, saveButtonProps, form } = useForm<OrgForm>({
    resource: 'organizations',
    action: 'create',
    redirect: 'list',
    meta: { parentId: communityId },
  });

  useEffect(() => {
    if (communityId) form?.setFieldValue('community_id', communityId);
  }, [communityId, form]);

  return (
    <Create saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        <Form.Item name="community_id" hidden>
          <Input />
        </Form.Item>
        <Form.Item name="name" label={t('common.name')} rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item
          name="slug"
          label={t('fields.slug')}
          rules={[{ required: true, pattern: /^[a-z0-9-]+$/ }]}
        >
          <Input dir="ltr" />
        </Form.Item>
        <Form.Item name="billing_contact" label={t('fields.billing_contact')}>
          <Input dir="ltr" />
        </Form.Item>
        <Form.Item
          name="subscription_tier"
          label={t('fields.subscription_tier')}
          rules={[{ required: true }]}
          initialValue="free"
        >
          <Select options={TIERS.map((t) => ({ value: t, label: t }))} />
        </Form.Item>
      </Form>
    </Create>
  );
}
